export const MARKETS_REQUEST = 'marketsRequest';
export const MARKETS_FAILURE = 'marketsFailure';
export const MARKETS_SUCCESS = 'marketsSuccess';
